import styled, {css} from 'styled-components';

import NotificationSvg from '../../assets/icons/primary/Notification.svg';
import {ms} from '../../styles/normalizeSize';
import {getAlphaColor, getColor} from '../../styles/utils';
import {View} from '../../uikit/View';
import {platform} from '../../utils/platform';

export const Container = styled(View)`
  ${platform.isWeb &&
  css`
    align-self: center;
  `}
`;

export const Icon = styled(NotificationSvg).attrs(_p => ({
  fill: getColor('icon3')(_p),
}))`
  width: ${ms(24)};
  height: ${ms(24)};
`;

export const IconContainer = styled(View)`
  position: relative;
  width: ${ms(40)};
  height: ${ms(40)};
  min-width: ${ms(40)};
  min-height: ${ms(40)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${getColor('background1')};
  border-radius: ${ms(50)};
  box-shadow: 0 ${ms(4)} ${ms(20)} ${getAlphaColor('global2', 0.05)};
  border: 1px solid ${getColor('border1')};

  ${platform.isWeb &&
  css`
    &:hover {
      box-shadow: none;
      ${Icon} {
        fill: ${getColor('icon4')};
      }
    }
  `}
`;

export const Badge = styled(View)`
  position: absolute;
  left: ${ms(20)};
  top: ${ms(10)};
  width: ${ms(8)};
  height: ${ms(8)};
  background-color: ${getColor('error')};
  border: 1px solid ${getColor('background1')};
  border-radius: ${ms(4)};
`;
